var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mt-4"},[_c('label',{staticClass:"block w-full text-xm font-normal mt-8 pb-3 text-base",attrs:{"for":"emailAddress"}},[_vm._v("Email address")]),_vm._l((_vm.emails),function(email,key){return [_c('vs-input',{key:key,staticClass:"mt-2",attrs:{"value":email,"size":"large","disabled":""}})]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }